import { ReactNode } from 'react'
import { CloseIcon } from './icons'

export function BatchActionToolbar({
  selectionMessage,
  onClearSelection,
  children
}: {
  selectionMessage?: string
  onClearSelection?: () => void
  children?: ReactNode
}) {
  return (
    <div className="flex h-14 w-full bg-gray-900 px-6 text-white">
      <div className="flex min-w-[800px] flex-row items-center">
        <div className="flex flex-row items-center">
          <button
            className="flex items-center gap-x-2 rounded-md bg-gray-700/70 px-3 py-2.5 text-base text-gray-200 hover:bg-gray-600/70"
            onClick={onClearSelection}
          >
            <CloseIcon className="h-4 w-4" />
            Clear selection
          </button>

          <div className="ml-3 text-base text-gray-300">{selectionMessage}</div>
        </div>

        <div className="ml-8 flex flex-row items-center gap-6">{children}</div>
      </div>
    </div>
  )
}

export function BatchActionToolbarSection({
  title,
  children
}: {
  title: string
  children: ReactNode
}) {
  return (
    <div className="flex flex-row items-center gap-x-3">
      <div className="text-base text-gray-300">{title}</div>
      {children}
    </div>
  )
}

export function BatchActionToolbarSectionDivider() {
  return <div className="mx-2 h-6 w-px bg-gray-600/60" />
}

function BatchActionToolbarButton({
  icon,
  children,
  onClick,
  'aria-label': ariaLabel
}: {
  'icon'?: ReactNode
  'children': ReactNode
  'onClick'?: () => void
  'aria-label'?: string
}) {
  return (
    <button
      aria-label={ariaLabel}
      className="flex items-center gap-x-2 rounded-md bg-gray-600/30 px-3 py-2.5 text-base text-gray-200 hover:bg-gray-600/50"
      onClick={onClick}
    >
      {icon}
      {children}
    </button>
  )
}

function BatchActionToolbarDivider() {
  return <div className="mx-6 h-8 bg-gray-600/70" />
}

BatchActionToolbar.Button = BatchActionToolbarButton
BatchActionToolbar.Section = BatchActionToolbarSection
BatchActionToolbar.Divider = BatchActionToolbarDivider
BatchActionToolbar.SectionDivider = BatchActionToolbarSectionDivider
